import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { toastMessage } from "../../utils/toast";
import { useDispatch } from "react-redux";
import { getLocaleValue } from "../../utils";
import Loader from "react-loader-spinner";
import { biometricCheckout, getByBiometricBooking } from "../../Redux/Actions/biometricAppointment";
import { onMessageListener } from "../../utils/pushNotification";
import { useTranslation } from "react-i18next";
import { clearSession } from "../../utils/initiate";
import { useLocation, useHistory } from "react-router-dom";
import * as localizationActions from "../../Redux/Actions/localization";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { set } from "date-fns";


const BiometricCheckout = ({ history, match }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [currentItems, setCurrentItems] = useState([]);
    const {
        center,
        date,
        time,
        option
    } = location.state || {};
    const [balance, setBalance] = useState(0);
    const [currency, setCurrency] = useState("");
    const [totalAmount, setTotalAmount] = useState(0);
    const [errStatus, setErrStatus] = useState(200);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [payURL, setPayURL] = useState("");
    const [fcmToken, setFcmToken] = useState("");
    const [pageType, setPageType] = useState("");
    const [clickFlag, setClickFlag] = useState(false);
    const [showPaymentSuccessModal, setShowPaymentSuccessModal] = useState(false);
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");
    const { t, i18n } = useTranslation();
    const [currentLanguage, setCurrentLanguage] = useState(
        localStorage.getItem("i18nextLng")
    );

    onMessageListener().then(payload => {
        console.log(payload);
    }).catch(err => console.log('failed: ', err));


    useEffect(() => {
        //To Get English Localizations
        localizationActions
            .localization("EN")
            .then((res) => {
                if (res) {
                    setTimeout(() => {
                        localStorage.setItem("localEn", JSON.stringify(res));
                    }, 10);
                } else {
                    localStorage.setItem("localEn", "");
                    toastMessage(
                        "error",
                        (res && res.message) || `Unable to load the eng Localization`
                    );
                }
            })
            .catch((err) => {
                err.response?.status === 401 && clearSession(dispatch, history);
            });
        //-----------------------------------------------------------------------------------------------------
        //To Get Arabic Localizations
        localizationActions
            .localization("AR")
            .then((res) => {
                if (res) {
                    localStorage.setItem("localAr", JSON.stringify(res));
                } else {
                    localStorage.setItem("localAr", "");
                    toastMessage(
                        "error",
                        (res && res.message) || `Unable to load the ar Localization`
                    );
                }
            })
            .catch((err) => {
                err.response?.status === 401 && clearSession(dispatch, history);
            });

    }, []);

    const changeLanguage = (value) => {
        i18n.changeLanguage(value);
        setCurrentLanguage(value);
    };


    useEffect(() => {
        setLoading(true);
        const bookingDetails = {
            id: id,
            appointmentCenter: Number(center),
            appointmentDate: option === "IsAppointment" ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}T${time instanceof Date ? time.toTimeString().slice(0, 8) : time
                }` : null,
            appointmentSource: option || ""    
        };
        biometricCheckout(bookingDetails)
            .then((res) => {
                if (res?.data) {
                    setPayURL(res.data.paymentLink);
                    setTotalAmount(res.data.totalAmount);
                    setCurrency(res.data.currency);
                    let summary = res.data?.summary;
                    let summaryData = summary.map(({ amount, description }) => {
                        return {
                            amount: amount,
                            summary: getLocaleValue(description),
                        };
                    });
                    setCurrentItems(summaryData);
                }
                setLoading(false);
            })
            .catch((err) => {
                setButtonLoading(false);
                const errorMessage = err?.response?.data?.message || "Unable to fetch the payment details";
                if (errorMessage === "No Open Transaction Found for the entity") {
                    history.push(`/biometricTracking?id=${id}`);
                } else {
                    history.push("/biometricCheckout?id=" + id);
                }
                setLoading(false);
                toastMessage("error", errorMessage);
                err?.response?.status === 401 && clearSession(dispatch, history);
            });
        //setLoading(false);
    }, []);


    onMessageListener()
        .then((payload) => {
            let type = payload.data.type;
            if (type == "PAYMENT_SUCCESSFUL") {
                history.push(`/biometricTracking?id=${id}`);
            } else if (type == "PAYMENT_FAILED") {
                history.push(`/biometricCheckout?id=${id}`);
            } else if (type == "PAYMENT_COMPLETE") {
                history.push(`/biometricTracking?id=${id}`);
            }
        })
        .catch((err) => {
            setErrStatus(err?.response?.status);
        });
    const [parentWindow, setParentWindow] = useState([]);
    const openPaymentPage = () => {
        setButtonLoading(true);

        const windowFeatures = "width=900,height=700,top=60,left=300,scrollbars=yes,resizable=no";
        const paymentWindow = window.open(payURL, "PaymentWindow", windowFeatures);
        setParentWindow(paymentWindow);

        if (!paymentWindow || paymentWindow.closed || typeof paymentWindow.closed === "undefined") {
            alert("Please allow popups for this site.");
            setButtonLoading(false);
            return;
        }

        const targetOrigin = new URL(payURL).origin;

        const sendMessageInterval = setInterval(() => {
            try {
                const messagePayload = { fcmToken, type: "PAYMENT_LINK" };
                paymentWindow.postMessage(messagePayload, targetOrigin);
                console.log("✅ Message sent to payment window:", messagePayload);
                clearInterval(sendMessageInterval);
            } catch (err) {
                console.error("Error sending message to payment window:", err.message);
            }
        }, 300);

        const requestLocationInterval = setInterval(() => {
            if (!paymentWindow.closed) {
                paymentWindow.postMessage({ type: "get_location" }, targetOrigin);
                console.log("Requested location from payment window");

                getByBiometricBooking(id)
                    .then((res) => {
                        if (res && res.data && Array.isArray(res.data)) {
                            const booking = res.data[0];
                            const currentPageType = booking.pageType;
                            console.log("Booking PageType:", currentPageType);

                            if (currentPageType === "LOGS") {
                                console.log("✅ PageType is SCHEDULE, closing payment window.");
                                paymentWindow.close();
                                setButtonLoading(false);
                                clearInterval(requestLocationInterval);
                                clearInterval(checkWindowInterval);
                                window.removeEventListener("message", handleMessage);
                                setShowPaymentSuccessModal(true); // Show modal instead of reload/redirect
                                // window.location.reload();
                                // history.push(`/biometricCheckout?id=${id}`);
                            }
                        }
                    })
                    .catch((err) => {
                        setButtonLoading(false);
                        toastMessage("error", "Status changed");
                    });
            }
        }, 1000);

        // Handle messages from payment window
        const handleMessage = (event) => {

            console.log("Message received from payment window:", event.data);
            const { type, href, status } = event.data;
            console.log("Received message type:", type);
            console.log("Received message from payment window:", event.data);

            if (type === "location_response") {
                console.log("Payment Page URL:", href);
            }

            if (status === "payment_success" || status === "payment_failed") {
                console.log("Payment Status:", status);
                paymentWindow.close();
                setButtonLoading(false);
                clearInterval(requestLocationInterval);
                clearInterval(checkWindowInterval);
                window.removeEventListener("message", handleMessage);
                history.push(`/biometricCheckout?id=${id}`);
            }
        };

        const checkWindowInterval = setInterval(() => {
            if (paymentWindow.closed) {
                console.log("❌ Payment window was closed by user.");
                setButtonLoading(false);
                clearInterval(requestLocationInterval);
                clearInterval(checkWindowInterval);
                window.location.reload();
                window.removeEventListener("message", handleMessage);
                history.push(`/biometricCheckout?id=${id}`);
            }
        }, 500);

        window.addEventListener("message", handleMessage);
        console.log("Payment window opened with URL:", payURL);
    };

    useEffect(() => {
        if (parentWindow) {
            //the parent window to get the payment status
            const handleParentMessage = (event) => {
                if (event.origin !== payURL) return;

                const { type, status } = event.data;
                if (type === 'payment_status') {
                    console.log("Payment Status:", status);
                    if (status === 'success') {
                        history.push(`/biometricTracking?id=${id}`);
                    } else if (status === 'failed') {
                        history.push(`/biometricCheckout?id=${id}`);
                    }
                }
            }

            window.addEventListener('message', handleParentMessage);
            return () => {
                window.removeEventListener('message', handleParentMessage);
            }

        }
    }, [payURL, parentWindow, history, id]);


    const handlePaymentSuccessModalClose = () => {
        setShowPaymentSuccessModal(false);
        window.location.reload();
        history.push(`/biometricCheckout?id=${id}`);
    };

    return (
        <>
            {loading ? (
                <div className="d-flex align-items-center justify-content-center vh-100">
                    <Loader
                        type="ThreeDots"
                        color="#2d207d"
                        height={40}
                        width={40}
                        style={{ textAlign: "center" }}
                    />
                </div>
            ) : (
                <div>
                    <div className="d-flex flex-column vh-100" style={{ minHeight: "100%", background: "#f8f9fa", textAlign: "center" }}>
                        <div
                            className="container-fluid px-3"
                            style={{
                                width: "100%",
                                paddingTop: "1px",
                                paddingBottom: "20px",
                            }}
                        >
                            <div className="row align-items-center justify-content-between">

                                <div
                                    className="col-12 col-md-6 d-flex justify-content-center justify-content-md-start align-items-center flex-wrap"
                                    style={{ gap: "20px" }}
                                >
                                    <img
                                        src="/Assets/aamer_logistics_logo.png"
                                        alt="logo"
                                        style={{
                                            width: "35vw",
                                            maxWidth: "130px",
                                            marginTop: "73px",
                                        }}
                                    />
                                    <img
                                        src="/Assets/icp-logo.png"
                                        alt="logo"
                                        style={{
                                            width: "35vw",
                                            maxWidth: "130px",
                                            height: "auto",
                                        }}
                                    />
                                </div>

                                {/* Language Toggle - Desktop right / Mobile bottom-center */}
                                <div
                                    className="col-12 col-md-6 d-flex justify-content-center justify-content-md-end  mt-3 mt-md-0"
                                    style={{ gap: "10px" }}
                                >
                                    <span
                                        style={{
                                            fontSize: "20px",
                                            color: "#29235c",
                                            cursor: "pointer",
                                            borderBottom: currentLanguage === "english" ? "2px solid" : "0px",
                                            fontWeight: "bold",
                                        }}
                                        onClick={() => changeLanguage("english")}
                                    >
                                        EN
                                    </span>
                                    <span
                                        style={{
                                            fontSize: "20px",
                                            color: "#29235c",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        |
                                    </span>
                                    <span
                                        style={{
                                            fontSize: "20px",
                                            color: "#29235c",
                                            cursor: "pointer",
                                            borderBottom: currentLanguage === "arabic" ? "2px solid" : "0px",
                                            fontWeight: "bold",
                                        }}
                                        onClick={() => changeLanguage("arabic")}
                                    >
                                        AR
                                    </span>
                                </div>

                            </div>
                        </div>

                        <div>
                            <span
                                style={{
                                    fontSize: "30px",
                                    fontWeight: "500",
                                    borderBottom: "5px solid #29235c",
                                    paddingTop: "1%",
                                    color: "#29235c",
                                    display: "inline-block",
                                    marginBottom: "2%",
                                }}
                            >
                                {getLocaleValue("checkout_title")}
                            </span>
                        </div>
                        <div className="">
                            <div className="d-flex justify-content-center">
                                <div className="col-md-5">
                                    <div className="card">
                                        <div className="d-flex mt-2">
                                            <div
                                                className="col-lg-12 card"
                                                style={{ border: "0px solid" }}
                                            >
                                                <div className="card-body form-group fv-plugins-icon-container mb-0">
                                                    {/* <div className="d-flex justify-content-between"> */}
                                                    <div style={{ textAlign: "center" }}>
                                                        <div>
                                                            <span
                                                                className="card-title font-weight-bolder text-dark"
                                                                style={{ fontSize: "20px", fontWeight: "500", color: "#29235c" }}
                                                            >
                                                                {getLocaleValue("checkout_order_summary")}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {/* </div> */}
                                                    <div className="mt-1 d-flex flex-wrap">
                                                        <table
                                                            className="table tableFreez tablefix table-head-custom table-vertical-center table-head-bg"
                                                            style={{ marginBottom: "0px" }}
                                                        >
                                                            <tbody>
                                                                {currentItems.map(({ sno, summary, amount }) => {
                                                                    return (
                                                                        <tr key={sno}>
                                                                            <td>
                                                                                <span
                                                                                    className="text-dark-75 font-weight-bolder d-block font-size-lg"
                                                                                    style={{
                                                                                        fontWeight: "500",
                                                                                        fontSize: "20px",
                                                                                        color: "#29235c",
                                                                                    }}
                                                                                >
                                                                                    {summary}
                                                                                </span>
                                                                            </td>
                                                                            <td></td>

                                                                            <td>
                                                                                <span
                                                                                    className="text-dark-75 font-weight-bolder d-block font-size-lg"
                                                                                    style={{
                                                                                        fontWeight: "500",
                                                                                        fontSize: "20px",
                                                                                        color: "#29235c",
                                                                                    }}
                                                                                >
                                                                                    {amount} {currency}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                                <tr>
                                                                    <td>
                                                                        <span
                                                                            style={{ fontWeight: 500, fontSize: "20px", color: "#29235c" }}
                                                                        >
                                                                            {getLocaleValue("checkout_total")}
                                                                        </span>
                                                                    </td>
                                                                    <td></td>
                                                                    <td>
                                                                        <span
                                                                            style={{ fontWeight: 500, fontSize: "20px", color: "#29235c" }}
                                                                        >
                                                                            {`${totalAmount} ${currency}`}{" "}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    {
                                                        <div
                                                            style={{ display: "flex", justifyContent: "center" }}
                                                        >
                                                            <button
                                                                className="btn d-flex align-items-center"
                                                                disabled={buttonLoading}
                                                                onClick={openPaymentPage}
                                                                style={{
                                                                    backgroundColor: "#29235c",
                                                                    color: "#fff",
                                                                    borderRadius: "5px",
                                                                    padding: "10px 20px",
                                                                    fontSize: "16px",
                                                                    fontWeight: "bold",
                                                                }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        fontWeight: 500,
                                                                        fontSize: "15px",
                                                                        padding: "5px",
                                                                    }}
                                                                >
                                                                    {buttonLoading
                                                                        ? getLocaleValue("payment_processing")
                                                                        : getLocaleValue("checkout_btn")}
                                                                </span>
                                                                {buttonLoading && (
                                                                    <Loader
                                                                        type="Oval"
                                                                        color="#fff"
                                                                        height={20}
                                                                        width={20}
                                                                        style={{ marginLeft: "10px" }}
                                                                    />
                                                                )}
                                                            </button>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <Modal
                show={showPaymentSuccessModal}
                onHide={handlePaymentSuccessModalClose}
                centered
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton={false}>
                    <Modal.Title>
                        <span style={{ display: "flex", alignItems: "center" }}>
                            {currentLanguage === "english" ? "Payment Status" : "الدفع ناجح"}
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        {/* Big centered Tick Icon */}
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="80"
                            height="90"
                            fill="green"
                            viewBox="0 0 24 24"
                            style={{ marginBottom: "30px" }}
                        >
                            <circle cx="12" cy="12" r="12" fill="#e6f4ea" />
                            <path
                                d="M17.707 8.293a1 1 0 00-1.414 0l-5.293 5.293-2.293-2.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l6-6a1 1 0 000-1.414z"
                                fill="green"
                            />
                        </svg>
                        <span style={{ fontSize: "22px", fontWeight: "bold", textAlign: "center" }}>
                            {currentLanguage === "english" ? "Your payment was successful!" : "تم الدفع بنجاح!"}
                        </span>
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ justifyContent: "center" }}>
                    <Button variant="primary" onClick={handlePaymentSuccessModalClose}>
                        {currentLanguage === "english" ? "Close" : "إغلاق"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default BiometricCheckout;

